import React from 'react';

const DeleteConfirmModal = React.memo(({ deleteModal, setDeleteModal, handleDelete }) => {
  if (!deleteModal) return null;

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setDeleteModal(null)}>
      <div className="delete-modal">
        <div className="modal-header">
          <h3>Ürün Sil</h3>
          <button className="modal-close" onClick={() => setDeleteModal(null)}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="delete-modal-body">
          <i className="fas fa-exclamation-triangle warning-icon"></i>
          <p>
            <strong>"{deleteModal.name}"</strong> adlı ürünü silmek istediğinizden emin misiniz?
          </p>
          <p className="delete-warning">Bu işlem geri alınamaz.</p>
        </div>
        <div className="delete-modal-actions">
          <button className="btn-cancel" onClick={() => setDeleteModal(null)}>
            İptal
          </button>
          <button className="btn-delete-confirm" onClick={handleDelete}>
            <i className="fas fa-trash"></i> Sil
          </button>
        </div>
      </div>
    </div>
  );
});

export default DeleteConfirmModal;
